export const GET_SKILLS_FOR_GOAL = 'GET_SKILLS_FOR_GOAL';
export const ADD_SKILL = 'ADD_SKILL';
export const PATCH_SKILL = 'PATCH_SKILL';
export const DELETE_SKILL = 'DELETE_SKILL';